import { TextShimmer } from "@@/shared/pictures/shimmers";
import { cn } from "@@/shared/utils/cn";
import type { AppTheme } from "@@/styles/theme";
import { useTranslate } from "@@/translations/use-translate";
import type { Interpolation } from "@emotion/react";
import type {
    Percentage,
    Translatable,
    TranslatableValueFactoryParams,
} from "@towni/common";
import type { MouseEventHandler } from "react";
import type { Except } from "type-fest";

type ParagraphText = {
    _type: "PARAGRAPH_TEXT";
    text: Translatable | TranslatableValueFactoryParams | undefined;
    textWhenEmpty?: Translatable;
    onClick?: MouseEventHandler<HTMLSpanElement>;
    disabled?: boolean;
    css?: Interpolation<AppTheme>;
    className?: string;
    spin?: boolean;
    spinWidth?: number;
    spinOpacity?: Percentage;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isParagraphText = (item: any): item is ParagraphText => {
    return item?._type === "PARAGRAPH_TEXT";
};

const paragraphTextFactory = (
    params: Except<ParagraphText, "_type">,
): ParagraphText => {
    return {
        _type: "PARAGRAPH_TEXT",
        ...params,
    };
};

const ParagraphText = (props: { text: ParagraphText }) => {
    const translate = useTranslate();
    const textContent =
        translate(props.text.text) || translate(props.text.textWhenEmpty);
    const onClick = props.text.disabled ? undefined : props.text.onClick;
    const defaultClassNames = cn("inline-block whitespace-pre-wrap", {
        " visited:text-primary focus:text-primary active:text-primary hover:text-secondary underline cursor-pointer":
            !!onClick,
    });
    const spinClassNames = "inline-block float-left mt-[3px] clear-both";

    return props.text.spin ? (
        <span
            className={cn(props.text.className, spinClassNames)}
            style={{
                width: props.text.spinWidth ?? 100,
            }}>
            <TextShimmer rows={1} />
        </span>
    ) : (
        <span
            className={cn(defaultClassNames, props.text.className)}
            onClick={onClick}>
            {textContent}
        </span>
    );
};

export { isParagraphText, ParagraphText, paragraphTextFactory };
